import React, { useMemo } from 'react';
import { useSortBy, useTable } from "react-table"
import { Table } from "reactstrap"

const ExistingDropshipsTable = ({ dropships }) => {

  const columns = React.useMemo(
    () => [
      {
        Header: "Order ID",
        accessor: "order_id",
      },
      {
        Header: "Line Item ID",
        accessor: "line_item_id",
      },
      {
        Header: "Destination",
        accessor: (row) => {
          if (row.destination === "customer") return "Customer";
          if (row.destination === "customer_franco") return "Franco";
          return row.destination;
        }
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "SKU",
        accessor: "sku",
      },
    ],
    []
  );


  const rowData = useMemo(() => dropships, [dropships])

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns: columns,
        data: rowData,
      },
      useSortBy
    )

  return (
    <>
      <div
        className="table-responsive react-table mt-1"
        style={{ maxHeight: "650px" }}
      >
        <h5>Already Dropshipped</h5>
        <Table {...getTableProps()} className="custom-header-css">
          <thead className="table-light table-head">
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                
              </tr>
            ))}
          </thead>
          <tbody>
            <tr>
              <td colSpan={3}>
                <Table
                  {...getTableProps()}
                  className="custom-header-css add-move-shipment-table"
                >
                  <thead className="table-light table-head">
                    {headerGroups.map((headerGroup, i) => (
                      <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                        {rows.length ? <th></th> : null}
                        {headerGroup.headers.map((column, i) => {
                          return (
                            <th key={i} {...column.getHeaderProps()}>
                              <div
                                style={{ minHeight: "unset" }}
                                {...(column.Header == "Code" ||
                                  column.Header == "Address" ||
                                  column.Header == "Action"
                                  ? null
                                  : column.getSortByToggleProps())}
                              >
                                {column.render("Header").toUpperCase()}
                              </div>
                            </th>
                          )
                        })}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {rows && rows?.length > 0 ? (
                      rows.map((row, i) => {
                        prepareRow(row)
                        return (
                          <tr key={i} {...row.getRowProps()}>
                            <td></td>
                            {row.cells.map((cell, i) => {
                              return (
                                <td
                                  style={{ fontSize: 12 }}
                                  key={i}
                                  {...cell.getCellProps()}
                                >
                                  {cell.render("Cell")}
                                </td>
                              )
                            })}
                          </tr>
                        )
                      })
                    ) : (
                      <tr>
                        <td colSpan="9" className="no-found-data">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </td>
            </tr>
          </tbody>
        </Table>
      </div >
    </>
  )
};

export default ExistingDropshipsTable;
